import { useEffect, useReducer } from 'react';
import { fetchReducer, FETCH_ACTION_TYPES } from 'reducers/fetchReducer';
import { getTransactionHistory } from 'api/user/orders/transactionHistory';

const initialState = {
  loading: false,
  error: false,
  data: null,
};

const useTransactionHistoryFetch = () => {
  const [state, dispatch] = useReducer(fetchReducer, initialState);
  useEffect(() => {
    let ignore = false;
    const fetch = async () => {
      dispatch({ type: FETCH_ACTION_TYPES.loading, payload: { loading: true } });
      try {
        const response = await getTransactionHistory();

        if (!ignore) {
          dispatch({ type: FETCH_ACTION_TYPES.setData, payload: { data: response.transactions } });
        }
      } catch (e) {
        if (!ignore) {
          dispatch({ type: FETCH_ACTION_TYPES.setError, payload: { error: e } });
        }
      }
    };

    fetch();

    return () => {
      ignore = true;
    };
  }, []);

  return [state];
};

export default useTransactionHistoryFetch;
